<template>
  <li>
    <AppInfoTextBlock
      :label-text="labelText"
      :text="currentText"
      :is-link="isLink"
      :href="href"
      :is-router-link="isRouterLink"
      :route="route"
    />
  </li>
</template>

<script>
import AppInfoTextBlock from '@/components/page/text/AppInfoTextBlock'
import { MIXIN_INFO_TEXT } from '@/mixins/components/mixinInfoText'
import { getHandbookName } from '@/utils/string'

export default {
  name: 'PtoInfoListItem',
  components: {
    AppInfoTextBlock
  },
  mixins: [MIXIN_INFO_TEXT],
  props: {
    isHandbook: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentText () {
      return this.isHandbook ? getHandbookName(this.text) : this.text
    }
  }
}
</script>
